// src/blocks/move/moveRight.ts

import * as Blockly from 'blockly';
import { javascriptGenerator } from 'blockly/javascript';
import { BlocklyFields } from '../../BlocklyFields';
import i18next from 'i18next';

export function initMoveLeftBlock() {

    Blockly.Blocks[BlocklyFields.MOVE_LEFT] = {
        init: function () {
            this.jsonInit({
                "type": BlocklyFields.MOVE_LEFT,
                "message0": '%1 ' + i18next.t('blockly.move.left.message', 'Move left'),
                "args0": [
                    {
                        "type": "field_image",
                        "src": "/images/blocks/left.png", // Lien vers votre icône (chemin relatif ou absolu)
                        "width": 16,   // Largeur de l'image
                        "height": 16,  // Hauteur de l'image

                    }
                ],
                "previousStatement": null,
                "nextStatement": null,
                "colour": '#FF6680', // Vous pouvez choisir une autre couleur si vous le souhaitez
                "tooltip": i18next.t('blockly.move.right.tooltip', ''),
                "helpUrl": ""
            });
        },
    };

    javascriptGenerator.forBlock[BlocklyFields.MOVE_LEFT] = function (block, generator) {
        return 'await walkCharacter(180);\n';
    }
}
